import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SellerLayout from './SellerLayout';

const SellerOrders = () => {
  const [loading, setLoading] = useState(true);
  const [shopName, setShopName] = useState('');
  const [orders, setOrders] = useState([]);
  const [deliveryMap, setDeliveryMap] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get('/api/seller/orders-data', {
          withCredentials: true,
        });

        if (res.data && res.data.ok) {
          setShopName(res.data.shop_name || '');
          setOrders(Array.isArray(res.data.orders) ? res.data.orders : []);
          setDeliveryMap(res.data.delivery_map || {});
        } else {
          alert(res.data?.error || '주문 목록을 불러오지 못했습니다.');
        }
      } catch (err) {
        const redirect = err?.response?.data?.redirect;
        const error = err?.response?.data?.error;
        if (redirect) {
          window.location.href = redirect;
          return;
        }
        alert(error || '주문 목록을 불러오지 못했습니다.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const formatNumber = (n) => Number(n || 0).toLocaleString('ko-KR');

  const renderPaymentBadge = (status) => {
    let bg = '#6c757d';
    if (status === '결제완료') bg = '#198754';
    else if (status === '결제취소') bg = '#6c757d';

    return (
      <span style={{ ...styles.badge, background: bg }}>
        {status || ''}
      </span>
    );
  };

  const renderStatusCell = (row) => {
    const orderStatus = String(row.status || '').trim();
    const addr = String(row.delivery_address || '').trim();
    const isPickup = addr === '' || addr.includes('매장 픽업');

    let label = '';
    let badgeStyle = styles.badgeSecondary;

    if (orderStatus === '주문취소') {
      label = '주문취소';
      badgeStyle = styles.badgeSecondary;
    } else {
      if (isPickup) {
        const ps = String(row.current_status || 'NEW').trim();

        if (ps === 'NEW') {
          label = '픽업 · 새주문';
          badgeStyle = styles.badgeDanger;
        } else if (ps === 'ACCEPTED') {
          label = '픽업 · 접수';
          badgeStyle = styles.badgePrimary;
        } else if (ps === 'COOKING') {
          label = '픽업 · 준비중';
          badgeStyle = styles.badgeWarning;
        } else if (ps === 'DONE') {
          label = '픽업 · 완료';
          badgeStyle = styles.badgeSuccess;
        } else if (ps === 'CANCELLED') {
          label = '픽업 · 취소';
          badgeStyle = styles.badgeSecondary;
        } else {
          label = `픽업 · ${ps}`;
          badgeStyle = styles.badgeSecondary;
        }
      } else {
        if (deliveryMap[row.id]) {
          const ds = row.delivery_status || '';

          if (ds) {
            label = ds;
            if (ds === '배송중') badgeStyle = styles.badgePrimary;
            else if (ds === '배송완료') badgeStyle = styles.badgeSuccess;
            else badgeStyle = styles.badgeWarning;
          } else {
            label = '배송상태 없음';
            badgeStyle = styles.badgeDanger;
          }
        } else {
          label = '미입력';
          badgeStyle = styles.badgeDanger;
        }
      }
    }

    const manageUrl = isPickup
      ? `/seller/pickup/edit?order_id=${row.id}`
      : `/seller/delivery/edit?order_id=${row.id}`;

    return (
      <div style={styles.statusWrap}>
        <div style={{ minWidth: '120px' }}>
          <span style={badgeStyle}>{label}</span>
        </div>
        <a href={manageUrl} style={styles.manageBtn}>
          관리
        </a>
      </div>
    );
  };

  if (loading) {
    return (
      <SellerLayout shopName={shopName}>
        <div style={styles.loading}>로딩중...</div>
      </SellerLayout>
    );
  }

  return (
    <SellerLayout shopName={shopName}>
      <div style={styles.pageTopSpace}></div>
      <h2 style={styles.title}>주문 목록</h2>

      <div style={styles.tableResponsive}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>ID</th>
              <th style={styles.th}>주문자</th>
              <th style={styles.th}>전화번호</th>
              <th style={styles.th}>배송주소</th>
              <th style={styles.th}>결제수단</th>
              <th style={styles.th}>총액</th>
              <th style={styles.th}>주문일</th>
              <th style={styles.th}>결제정보</th>
              <th style={styles.th}>상태정보</th>
              <th style={styles.th}>상세</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((row) => (
              <tr key={row.id}>
                <td style={styles.td}>{row.id}</td>
                <td style={styles.td}>{row.buyer_name || ''}</td>
                <td style={styles.td}>{row.buyer_phone || ''}</td>
                <td
                  style={styles.td}
                  dangerouslySetInnerHTML={{
                    __html: String(row.delivery_address || '').replace(/\n/g, '<br>')
                  }}
                />
                <td style={styles.td}>{row.payment_method || ''}</td>
                <td style={styles.td}>{formatNumber(row.result_price)}원</td>
                <td style={styles.td}>{row.order_date}</td>
                <td style={styles.td}>{renderPaymentBadge(row.status)}</td>
                <td style={styles.td}>{renderStatusCell(row)}</td>
                <td style={styles.td}>
                  <a
                    href={`/seller/order/view?id=${row.id}`}
                    style={styles.detailBtn}
                  >
                    상세 보기
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </SellerLayout>
  );
};

const styles = {
  loading: {
    padding: '40px 0',
  },
  pageTopSpace: {
    height: '8px',
  },
  title: {
    marginTop: '8px',
    marginBottom: '20px',
    fontWeight: 'bold',
  },
  tableResponsive: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    whiteSpace: 'nowrap',
    textAlign: 'center',
  },
  th: {
    border: '1px solid #dee2e6',
    padding: '12px',
    background: '#f8f9fa',
    fontWeight: 600,
    verticalAlign: 'middle',
  },
  td: {
    border: '1px solid #dee2e6',
    padding: '12px',
    verticalAlign: 'middle',
  },
  badge: {
    display: 'inline-block',
    color: '#fff',
    borderRadius: '999px',
    padding: '4px 8px',
    fontSize: '12px',
    fontWeight: 600,
  },
  badgeSuccess: {
    display: 'inline-block',
    minWidth: '95px',
    textAlign: 'center',
    background: '#198754',
    color: '#fff',
    borderRadius: '999px',
    padding: '4px 8px',
    fontSize: '12px',
    fontWeight: 600,
  },
  badgeSecondary: {
    display: 'inline-block',
    minWidth: '95px',
    textAlign: 'center',
    background: '#6c757d',
    color: '#fff',
    borderRadius: '999px',
    padding: '4px 8px',
    fontSize: '12px',
    fontWeight: 600,
  },
  badgePrimary: {
    display: 'inline-block',
    minWidth: '95px',
    textAlign: 'center',
    background: '#0d6efd',
    color: '#fff',
    borderRadius: '999px',
    padding: '4px 8px',
    fontSize: '12px',
    fontWeight: 600,
  },
  badgeWarning: {
    display: 'inline-block',
    minWidth: '95px',
    textAlign: 'center',
    background: '#ffc107',
    color: '#212529',
    borderRadius: '999px',
    padding: '4px 8px',
    fontSize: '12px',
    fontWeight: 600,
  },
  badgeDanger: {
    display: 'inline-block',
    minWidth: '95px',
    textAlign: 'center',
    background: '#dc3545',
    color: '#fff',
    borderRadius: '999px',
    padding: '4px 8px',
    fontSize: '12px',
    fontWeight: 600,
  },
  statusWrap: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    minWidth: '220px',
  },
  manageBtn: {
    marginLeft: 'auto',
    display: 'inline-block',
    border: '1px solid #0dcaf0',
    color: '#0dcaf0',
    textDecoration: 'none',
    borderRadius: '6px',
    padding: '4px 8px',
    fontSize: '12px',
  },
  detailBtn: {
    display: 'inline-block',
    border: '1px solid #6c757d',
    color: '#6c757d',
    textDecoration: 'none',
    borderRadius: '6px',
    padding: '4px 8px',
    fontSize: '12px',
  },
};

export default SellerOrders;